<template>
    <div>
        <header-section
            title="Executive Dashboard"
            set-position="relative"
            set-width="100">
        </header-section>
        <div id="app" class="o-content ie p-executive-dashboard">
            <icons></icons>

            <page-header></page-header>

            <page-form></page-form>

            <div class="u-margin-bottom-40">
                <reserve-section></reserve-section>
            </div>

            <div class="u-margin-bottom-40">
                <numbers-section></numbers-section>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    import Control from 'components/form/Control.vue';
    import FilterOptions from 'components/filter/FilterOptions.vue';
    import Icons from 'components/Icons.vue';
    import IconTooltip from 'components/IconTooltip.vue';
    import NumberCounter from 'components/NumberCounter';
    import OptionFilters from 'components/OptionFilters';
    import OptionList from 'components/OptionList';
    import OverviewBox from 'components/OverviewBox';
    import PageForm from 'pages/executive-dashboard/components/PageForm';
    import PageHeader from 'pages/executive-dashboard/components/PageHeader';
    import ReservesCharts from 'pages/executive-dashboard/components/charts/SummaryCharts';
    import SwitchButton from 'components/form/SwitchButton';
    import {mapActions, mapGetters} from 'vuex';
    import ReserveSection from "./components/ReserveSection";
    import NumbersSection from "./components/NumbersSection";
    import HeaderSection from 'components/Header.vue';

    export default {
        name: 'executive-dashboards',
        data() {
            return {
                chartView: 'all'
            }
        },
        components: {
            NumbersSection,
            ReserveSection,
            Control,
            FilterOptions,
            Icons,
            IconTooltip,
            NumberCounter,
            OptionFilters,
            OptionList,
            OverviewBox,
            PageForm,
            PageHeader,
            ReservesCharts,
            SwitchButton,
            HeaderSection
        },
        computed: {
            ...mapGetters('http', [
                'running',
                'apiRouteRequestRunning'
            ]),
            ...mapGetters('dashboards', [
                'averageReservesChartData',
                'totalReservesChartData',
                'diseaseType',
            ]),
        },
        mounted() {
            this.updateAll();
        },
        methods: mapActions('dashboards', [
            'executiveDashboard',
            'updatePeriod',
            'updateAll',
            'updateAverageReservesType',
            'updateTotalReservesType'
        ]),
    }
</script>



// WEBPACK FOOTER //
// ExecutiveDashboard.vue?4a2cc788